/**
 * @generated SignedSource<<b5d0897484f4492f068fe521410d0ba0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeatureToggleDataKind = "abandonedCartReminder" | "courseRecommendations" | "experimentalMode" | "inProductExpressCheckout" | "noConsentOrderAttribution" | "paymentProviderInvoiceNotice" | "profileEnrichmentSetName" | "scheduledGlobalDiscount" | "secciDownloadCheckout" | "signupMarketingOptIn" | "splitCourseCertification" | "storyblokCampaigns" | "timeBasedLicenses";
export type EditFeatureToggleDataInput = {
  clientMutationId?: string | null;
  id: string;
  isActive?: boolean | null;
  name?: string | null;
};
export type featureTogglesScreen_EditFeatureToggleMutation$variables = {
  input: EditFeatureToggleDataInput;
};
export type featureTogglesScreen_EditFeatureToggleMutation$data = {
  readonly Admin: {
    readonly FeatureToggle: {
      readonly editFeatureToggle: {
        readonly clientMutationId: string | null;
        readonly featureToggle: {
          readonly data: {
            readonly isActive?: boolean;
            readonly kind: FeatureToggleDataKind;
            readonly name?: string;
          };
          readonly id: string;
        };
      } | null;
    };
  };
};
export type featureTogglesScreen_EditFeatureToggleMutation = {
  response: featureTogglesScreen_EditFeatureToggleMutation$data;
  variables: featureTogglesScreen_EditFeatureToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "TimeBasedLicensesFeatureToggleData",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "SplitCourseCertificationFeatureToggleData",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "AbandonedCartReminderFeatureToggleData",
  "abstractKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "CourseRecommendationsFeatureToggleData",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "ScheduledGlobalDiscountFeatureToggleData",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "SecciDownloadCheckoutFeatureToggleData",
  "abstractKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "SignupMarketingOptInFeatureToggleData",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "InProductExpressCheckoutFeatureToggleData",
  "abstractKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "ProfileEnrichmentSetNameFeatureToggleData",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "StoryblokCampaignsFeatureToggleData",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "PaymentProviderInvoiceNoticeFeatureToggleData",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "NoConsentOrderAttributionFeatureToggleData",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "featureTogglesScreen_EditFeatureToggleMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureToggleAdminMutationSchema",
            "kind": "LinkedField",
            "name": "FeatureToggle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditFeatureToggleDataPayload",
                "kind": "LinkedField",
                "name": "editFeatureToggle",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeatureToggle",
                    "kind": "LinkedField",
                    "name": "featureToggle",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "featureTogglesScreen_EditFeatureToggleMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureToggleAdminMutationSchema",
            "kind": "LinkedField",
            "name": "FeatureToggle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EditFeatureToggleDataPayload",
                "kind": "LinkedField",
                "name": "editFeatureToggle",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeatureToggle",
                    "kind": "LinkedField",
                    "name": "featureToggle",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a7f4f9c24ee9052f382625e81685aa39",
    "id": null,
    "metadata": {},
    "name": "featureTogglesScreen_EditFeatureToggleMutation",
    "operationKind": "mutation",
    "text": "mutation featureTogglesScreen_EditFeatureToggleMutation(\n  $input: EditFeatureToggleDataInput!\n) {\n  Admin {\n    FeatureToggle {\n      editFeatureToggle(input: $input) {\n        featureToggle {\n          id\n          data {\n            __typename\n            kind\n            ... on TimeBasedLicensesFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on SplitCourseCertificationFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on AbandonedCartReminderFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on CourseRecommendationsFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on ScheduledGlobalDiscountFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on SecciDownloadCheckoutFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on SignupMarketingOptInFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on InProductExpressCheckoutFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on ProfileEnrichmentSetNameFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on StoryblokCampaignsFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on PaymentProviderInvoiceNoticeFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n            ... on NoConsentOrderAttributionFeatureToggleData {\n              name\n              isActive\n              kind\n            }\n          }\n        }\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11285efbb4696755c7d3f00258079a7a";

export default node;
